import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsItamsConstants {
    // Labels
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static STEP_TITLE = "Details";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static TRADING_GOODS_LABEL = "Trading goods";
    static TRADING_GOODS_DESCRIPTION_LABEL = "Trading goods description";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_LABEL = "Previous application reference number";
    static VALID_FROM_DATE_LABEL = "Valid from date";
    static VALID_TO_DATE_LABEL = "Valid to date";
    static APPROVED_BY_LABEL = "Approved by";
    static APPROVAL_DATE_LABEL = "Approval Date";
    static COMMENTS_LABEL = "Comments";
    static OPEN_PREVIOUS_APPLICATION_BUTTON_LABEL_LABEL = "open previous application";
    // Controls
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static TRADING_GOODS_CONTROL_NAME = "tradingGoods";
    static TRADING_GOODS_DESCRIPTION_FORM_CONTROL_NAME = "tradingGoodsDescription";
    static REFERENCE_NUMBER_FORM_CONTROL_NAME = "referenceNumber";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_CONTROL_NAME = "previousReferenceNumber";
    static VALID_FROM_DATE_CONTROL_NAME = "validFromDate";
    static VALID_TO_DATE_CONTROL_NAME = "validToDate";
    static APPROVED_BY_CONTROL_NAME = "approvedUserId";
    static APPROVAL_DATE_CONTROL_NAME = "approvedDate";
    static COMMENTS_CONTROL_NAME = "comments";
    // LookupNames
    static APPLICATION_TYPE_LOOKUP_NAME = "ApplicationType";
    static TRADING_GOODS_LOOKUP_NAME = "TradingGoods";
    // Validation messages
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, tradingGoods: {
            required: `Trading goods ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, tradingGoodsDescription: {
            required: `Trading goods description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
